export default {
    // noCrisisRisk: {
    //     zoomValue: null,
    //     isFontActive: false,
    //     isAnimationDisable: true,
    //     isCursorActive: null,
    //     isScreenRulerActive: null,
    //     filtersActive: [
    //         {
    //             filterType: "saturate",
    //             name: "Saturate",
    //             min: 0,
    //             max: 400,
    //             step: 5,
    //             value: 70,
    //             unit: "%",
    //         },
    //     ],
    // },
    visualImpairments: {
        type: "Zooms",
        icon: "fluent:eye-24-regular",
        zoomValue: 150,
        moduleZoomValue: 130,
        isFontActive: false,
        isAnimationDisable: false,
        isCursorActive: null,
        isScreenRulerActive: null,
        isScreenReaderActive: false,
        filtersActive: [
            {
                filterType: "contrast",
                name: "Contrast",
                min: 5,
                max: 400,
                step: 10,
                value: 120,
                unit: "%",
            },
        ],
    },
    colors: {
        type: "Teintes et luminosité",
        icon: "fluent:paint-brush-24-regular",
        zoomValue: null,
        isFontActive: false,
        isAnimationDisable: false,
        isCursorActive: null,
        isScreenRulerActive: null,
        isScreenReaderActive: false,
        filtersActive: [],
    },
    screenReader: {
        type: "Lecteur d'écran",
        icon: "material-symbols:auto-read-play",
        zoomValue: null,
        isFontActive: false,
        isAnimationDisable: false,
        isCursorActive: null,
        isScreenRulerActive: false,
        isScreenReaderActive: true,
        filtersActive: [],
    },
    cognitiveImpairments: {
        type: "Règle d'écran",
        icon: "fluent:brain-circuit-24-regular",
        zoomValue: 110,
        isFontActive: false,
        isAnimationDisable: false,
        isCursorActive: false,
        isScreenRulerActive: true,
        isScreenReaderActive: false,
        filtersActive: [],
    },
    cursor: {
        type: "Curseur",
        icon: "fluent:cursor-24-regular",
        zoomValue: null,
        isFontActive: false,
        isAnimationDisable: false,
        isCursorActive: true,
        cursorScale: 140,
        isScreenRulerActive: false,
        isScreenReaderActive: false,
        filtersActive: [],
    },
    dyslexic: {
        type: "Dyslexie",
        icon: "fluent:text-font-24-regular",
        zoomValue: null,
        isFontActive: true,
        isAnimationDisable: false,
        isCursorActive: null,
        isScreenRulerActive: false,
        isScreenReaderActive: false,
        filtersActive: [],
    },
    simpleKeyboard: {
        type: "Clavier visuel",
        icon: "fluent:keyboard-24-regular",
        zoomValue: null,
        isFontActive: false,
        isAnimationDisable: false,
        isCursorActive: null,
        isScreenRulerActive: null,
        isScreenReaderActive: false,
        filtersActive: [],
    },
    darkMode: {
        zoomValue: null,
        isFontActive: false,
        isAnimationDisable: false,
        isCursorActive: null,
        isScreenRulerActive: null,
        isScreenReaderActive: false,
        filtersActive: [
            {
                filterType: "invert",
                name: "Invert",
                min: 0,
                max: 100,
                step: 5,
                value: 100,
                unit: "%",
            },
        ],
    },
};
